import {UiServiceV2} from '@gongxigames/framework/slotV2/baseClasses/uiServiceV2/UIServiceV2';
import {turboControlStore} from './TurboControlStore';
import {ReelsSpeedLevel} from '@gongxigames/framework/slotV2/types';

export class TurboControlService extends UiServiceV2 {
    public static NAME = 'TurboControlService';

    onSetupEvents(): void {
        this.emitter.on('UI.turboBtn.pressed', this.onTurboBtn.bind(this));
        this.emitter.on('UI.reelSpin.setLevel', this.onSetLevel.bind(this));
    }

    private onSetLevel(nextSpeedLevel: ReelsSpeedLevel): void {
        turboControlStore.reelsSpeedLevel.value = nextSpeedLevel;
    }

    private onTurboBtn() {
        const nextSpeedLevel = turboControlStore.reelsSpeedLevel.value === ReelsSpeedLevel.turbo_2 ?
            ReelsSpeedLevel.normal : turboControlStore.reelsSpeedLevel.value + 1;

        turboControlStore.reelsSpeedLevel.value = nextSpeedLevel;
    }
}